<template>
  <div class="home">
    <section class="hero--home">
      <div class="container hero--home__container">
        <div class="hero--home__image">
          <div class="hero--home__image-group relative">
            <img class="building-animation__base" src="@/assets/that-picture-base.png" alt="">
            <img class="building-animation__1 absolute pin-t pin-l" src="@/assets/that-picture-1.png" alt="">
            <img class="building-animation__2 absolute pin-t pin-l" src="@/assets/that-picture-2.png" alt="">
            <img class="building-animation__3 absolute pin-t pin-l" src="@/assets/that-picture-3.png" alt="">
            <img class="building-animation__4 absolute pin-t pin-l" src="@/assets/that-picture-4.png" alt="">
            <img class="building-animation__5 absolute pin-t pin-l" src="@/assets/that-picture-5.png" alt="">
          </div>
        </div>
        <div class="hero--home__content">
          <h1 class="hero--home__title" v-t="'hero.title'">立即運用OBS™服務解決商務痛點</h1>
          <h1 class="hero--home__title--mobile">
            <div v-t="'hero.mobileTitle[0]'">立即運用 OBS™ 服務</div>
            <div v-t="'hero.mobileTitle[1]'">解決商務痛點</div>
          </h1>
          <p class="hero--home__desc" v-t="'hero.description'">無論您是哪個產業，需要更安全透明化的商務流程或生產更讓客戶信賴的產品，OBS™服務應用區塊鏈技術幫您打造具有信服力的商業服務</p>
          <div class="hero--home__btn__wrap">
            <a href="#"><div class="btn btn-solid btn-blue-light gradient-btn" @click.prevent="openContactForm">{{ $t('contactAndBuy') }}<i class="owl-direction-right"></i></div></a>
          </div>
        </div>
      </div>
    </section>
    <section class="bg-grey-lightest">
      <div class="container py-32">
        <h2 v-t="'blockChainDiscovery'">區塊鏈產業應用特點</h2>
        <div class="industry">
          <template v-for="industry in industries">
            <div v-if="!industry.hide" class="industry__wrap flex" :key="industry.id">
              <div class="industry__card w-full" :class="{actived: industry.active}">
                <div class="industry__card__title--mobile">{{ industry.title | i18n }}</div>
                <router-link v-if="industry.active && industry.routername" :to="{ name: 'industry', params: { industry: industry.routername.name} }" class="industry__card__img" :style="{ backgroundImage: `url(${industry.logo ? $filters.imageUrl(industry.logo.url) : ''})`}"></router-link>
                <div v-else class="industry__card__img" :style="{ backgroundImage: `url(${industry.logo ? $filters.imageUrl(industry.logo.url) : ''})`}"></div>
                <div class="industry__card__content">
                  <div class="industry__card__title">{{ industry.title | i18n }}</div>
                  <ul class="industry__card__list">
                    <template v-for="(feature, index) in industry.features">
                      <li v-if="index < 3" class="indent-fix" :key="index">{{ feature.name | i18n }}</li>
                    </template>
                  </ul>
                </div>
                <div class="industry__btn__wrap">
                  <router-link v-if="industry.active && industry.routername && !industry.specificPage" :to="{ name: 'industry', params: { industry: industry.routername.name} }" class="btn btn-text btn-blue no-underline"><span class="mr-4">{{ $t('detail') }}</span><i class="owl-direction-right"></i></router-link>
                  <router-link v-if="industry.specificPage" :to="{ name: industry.specificPage }" class="btn btn-text btn-blue no-underline"><span class="mr-4">{{ $t('detail') }}</span><i class="owl-direction-right"></i></router-link>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </section>
    <section>
      <div class="container py-32">
        <h2 v-t="'partners'"></h2>
        <div class="partners">
          <div class="partners__wrap" v-for="partner in partners" :key="partner.id">
            <div class="partners__card">
              <a v-if="partner.url" :href="partner.url" target="_blank">
                <img :src="partner.logo ? $filters.imageUrl(partner.logo.url) : ''" alt="" class="partners__img">
              </a>
              <img v-else :src="partner.logo ? $filters.imageUrl(partner.logo.url) : ''" alt="" class="partners__img">
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="bg-grey-lightest">
      <div class="container pt-32">
        <h2 v-t="'caseStudy'"></h2>
        <div class="example__wrap">
          <template v-for="example in cases">
            <div class="example__card" v-if="!example.hide" :key="example.id">
              <div class="example__card__cover">
                <div class="videoWrapper">
                  <template>
                    <iframe :src="`https://www.youtube.com/embed/${$filters.i18n(example['youtubeID-i18n'])}?modestbranding=1`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </template>
                </div>
              </div>
              <div class="example__card__content">
                <div class="example__card__title">{{ example.title | i18n }}</div>
                <div class="example__card__description whitespace-pre-line leading-normal">{{ example.description | i18n }}</div>
                <div class="example__card__btn__wrap">
                  <a v-if="example.url" :href="example.url" class="btn btn-text btn-blue"><span class="mr-4">{{ $t('detail') }}</span><i class="owl-direction-right"></i></a>
                </div>
              </div>
            </div>
          </template>
          <!-- <div class="example__card">
            <div class="example__card__cover">
              <div class="videoWrapper">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/8ZqUjO125GM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
            <div class="example__card__content">
              <div class="example__card__title">OwlNest 奧丁丁區塊鏈旅宿業管理服務</div>
              <div class="example__card__description">世界第一個以太坊區塊鏈為架構開發的旅宿業訂房及內部管理系統，智能合約彈性房價、萬種體驗加購服務都在奧丁丁。</div>
              <div class="example__card__btn__wrap">
                <div class="btn btn-text btn-blue">{{ $t('detail') }}</div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </section>
    <section class="belt bg-white">
      <div class="container">
        <div class="belt__left flex flex-col justify-between">
          <div>
            <h2 v-t="'banner.title'">成為OBS™的合作夥伴</h2>
            <p v-t="'banner.description'">立即註冊將有專人與您聯繫，為您打造客製化OBS™服務</p>
          </div>
          <a href="javascript:void(0)" class="inline-block mb-48 cursor-default"><div class="btn btn-solid btn-blue belt-btn-rwd gradient-btn cursor-pointer" style="width: 350px; max-width: 80%;" @click.prevent="openContactForm">{{ $t('contactAndBuy') }} <i class="owl-direction-right"></i></div></a>
        </div>
        <div class="belt__right">
          <img class="p-32" src="@/assets/contact.png" alt="contact">
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import gql from 'graphql-tag'
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import API from '@/api/home.js'

export default {
  // apollo: {
  //   industries: {
  //     query: gql`query {
  //       industries {
  //         id
  //         name
  //         active
  //         logo {
  //           url
  //         }
  //         features {
  //           name
  //         }
  //       }
  //     }`
  //   },
  //   partners: {
  //     query: gql`query {
  //       partners {
  //         name
  //         url
  //         logo {
  //           url
  //         }
  //       }
  //     }`
  //   }
  // },
  data () {
    return {
      cases: []
    }
  },
  computed: {
    ...mapGetters([
      'industries',
      'partners'
    ])
  },
  methods: {
    ...mapActions([
      // 'fetchIndustries',
      'fetchPartners',
      'openContactForm'
    ]),
    get: function (page, table) {
      const data = require(`@/pages/${page}.json`)
      if (table) {
        return data[table]
      } else {
        return data
      }
    }
  },
  mounted () {
    // this.fetchIndustries()
    this.fetchPartners()
    API.videos().then(res => {
      this.cases = _.chain(res.data).orderBy(['sort'], ['asc']).value()
    })
    // this.industries = this.get('Home', 'industries')
    // this.partners = this.get('Home', 'partners')
  }
}
</script>

<style lang="sass" scoped>
h2
  @apply py-16 font-bold

.hero--home
  @apply bg-indigo-darkest bg-center
  background-image: url('~@/assets/home_cover_bg.jpg')
  background-size: 150% 100%
  transition: all 0.3s linear
  animation: float-bg 2.5s 0.6s infinite
  &__container
    @apply flex flex-col
    @screen md
      @apply flex-row
  &__image
    @apply flex items-center
    @apply mt-32 mb-16 w-full
    @screen sm
      @apply my-24
    @screen md
      width: 80%
  &__content
    @apply flex flex-col py-64 justify-center
  &__title
    @apply text-white font-bold mb-16
    @apply hidden
    @screen md
      @apply block
    &--mobile
      @apply text-white font-bold mb-16 text-center
      @apply block
      @screen md
        @apply hidden
  &__desc
    @apply text-white leading-normal mb-16
    @apply p-24 text-center
    max-width: 800px
    @screen md
      @apply p-0 text-left mb-64
  &__btn__wrap
      @apply text-center
      @screen md
        @apply text-right

.industry
  @apply flex flex-wrap pb-32 -m-8
  &__wrap
    @apply w-full
    @screen md
      @apply w-1/3
    @screen lg
      @apply w-1/4
  &__card
    @apply bg-white shadow rounded m-8 p-8 flex flex-wrap items-center justify-between opacity-50
    @screen md
      @apply flex-col p-16
    &.actived
      @apply opacity-100
    &__img
      padding-top: 100px
      @apply inline-block
      @apply w-1/4 bg-center bg-contain bg-no-repeat mr-16
      @screen md
        @apply block w-full mr-0 mb-16
        background-size: 70%
    &__content
      @apply inline-block flex-1
      @screen md
        @apply block w-full text-left
    &__title
      @apply text-grey-darker font-bold hidden
      @screen md
        @apply block mb-16
      &--mobile
        @apply text-grey-darker font-bold hidden w-full flex-no-shrink mt-8 ml-8
        @apply block
        @screen md
          @apply hidden
    &__list
      @apply list-reset flex flex-wrap
      @screen md
        @apply flex-col
      li
        @apply m-8 w-full
        @screen md
          @apply mx-0 my-4 w-auto
          // margin-left: -16px
        &:before
          content: '・'
  .indent-fix
    text-indent: -1em
    margin-left: 1em
  &__btn__wrap
    @apply text-right w-full
    .btn-text
      @apply p-4

.partners
  @apply flex flex-wrap
  &__wrap
    @apply w-1/2
    @screen sm
      @apply w-1/3
    @screen md
      @apply w-1/4
  &__card
    @apply ease
    // @apply cursor-pointer
    img
      @apply ease
      mix-blend-mode: multiply
      filter: grayscale(100%)
    &:hover
      // @apply bg-grey-lightest shadow-inner
      img
        filter: grayscale(0%)
.example
  &__wrap
    @apply pb-32
  &__card
    @apply mb-32
    @screen md
      @apply flex flex-wrap flex-no-shrink flex-no-grow
    &:not(:last-child)
      @apply border-b-1 border-grey-lighter pb-32
    &__cover
      @apply w-full
      @apply flex-1
      .videowrap
        padding:
          bottom: 0
          top: imageRatio(340, 150)
        width: 100%
    &__content
      @apply flex flex-col flex-1 px-8 py-16 justify-between
      @screen md
        @apply px-16
    &__title
      @apply text-grey-darkest font-bold text-lg mb-8
    &__description
      @apply flex-1
    &__btn__wrap
      @apply text-right
      .btn
        @apply pr-0 pb-0

.building-animation
  &__base
    z-index: 0
  &__1, &__2
    animation: float-city 4s 0.6s infinite
    transition: all ease-in-out
  &__4, &__5
    animation: float-element 3.5s infinite
    transition: all ease-in-out
  &__1
    animation-delay: 1.5s
    z-index: 2
  &__2
    z-index: 1
  &__4
    animation-delay: 1.3s
  &__5
    animation-delay: 1.8s

@keyframes float-bg
  0%
    background-size: 100% 100%
  50%
    background-size: 103% 103%
  100%
    background-size: 100% 100%

@keyframes float-city
  0%
    transform: translate(0, 0)
  50%
    transform: translate(0, -10px)
  100%
    transform: translate(0, 0)

@keyframes float-element
  0%
    transform: translate(0, 0)
  50%
    transform: translate(0, -5px)
  100%
    transform: translate(0, 0)
</style>
